// import { useEffect, useRef } from 'react';
import { React, useState } from "react";
import { FaBars } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { GrClose } from "react-icons/gr";
import { useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import logo from "./../Images/vistaplots-logo.png";

const Header = () => {
  const { loginData } = useSelector((store) => store.dataReducer);
  const [isOpen, setOpen] = useState(false);
  // const [isClose, setClose] = useState(false);
  const toggleOpen = () => {
    setOpen(!isOpen);
  };

  return (
    <>
      <header className="header">
        <div className="container">
          {/* <nav className="navbar navbar-expand-lg d-flex justify-content-between"> */}

          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center">
              <Link className="navbar-brand" to="/">
                <img className="logo-img" src={logo} height="60px" alt="" />
              </Link>
            </div>

            <div
              className={isOpen ? "menu-overlay active" : "menu-overlay"}
            ></div>
            <div className="d-flex align-items-center">
              <nav
                className={
                  isOpen
                    ? "open nav-menu uk-navbar-right"
                    : "nav-menu uk-navbar-right"
                }
              >
                {/* <div className='d-flex justify-content-between'> */}
                <div>
                  <Link
                    className="close-nav-menu navbar-brand1"
                    onClick={toggleOpen}
                    to=""
                  >
                    {/* <i className="fas fa-times"></i> */}
                    <GrClose />
                  </Link>
                </div>
                <div className="d-flex align-items-center">
                  <ul className="menu" style={{ marginBottom: "0px" }}>
                    <li className="menu-item">
                      <NavLink
                        to="/"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Home
                      </NavLink>
                    </li>
                    <li className="menu-item">
                      <NavLink
                        to="/about"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        {" "}
                        About
                      </NavLink>
                    </li>
                    <li className="hide-or-show menu-item">
                      <NavLink
                        aria-current="page"
                        className={({ isActive }) => (isActive ? "active" : "")}
                        to="/properties"
                      >
                        Properties
                      </NavLink>
                    </li>

                    {/* <li className="hide-or-show menu-item">
                                            <NavLink className={({ isActive }) => (isActive ? "active" : '')} to="/projects">Projects</NavLink>
                                        </li> */}


                    <li className="menu-item menu-item-has-children">
                      <NavLink className={({ isActive }) => (isActive ? "" : 'active')} to="#" data-toggle="sub-menu">Projects <span className='plus'><FiChevronDown /></span></NavLink>
                      <ul className="sub-menu min-250">

                        <li className="menu-item "><NavLink to="/investment-projects" title="Investment">
                          Investment</NavLink></li>
                        <li className="menu-item "><NavLink to="/residential-plots"
                          title="Buy / Sell Properties">
                          Residential Plots</NavLink></li>
                        {/* <li className="menu-item "><NavLink to="/commercial-projects"
                          title="Buy / Sell Properties">
                          Commercial</NavLink></li> */}

                      </ul>



                    </li>


                    <li className="menu-item menu-item-has-children">
                      <NavLink className={({ isActive }) => (isActive ? "" : 'active')} to="" data-toggle="sub-menu">Services <span className='plus'><FiChevronDown /></span></NavLink>
                      <ul className="sub-menu min-380">

                        <li className="menu-item menu-item-has-children-inner"><NavLink to="" title="Investment in Real Estate Land Devlopment">
                          Investment in Real Estate Land Devlopment</NavLink>
                          <ul className="sub-menu-inner min-250">

                            <li className="menu-item "><NavLink to="/residential-land" title="Residential Land">
                              Residential Land</NavLink></li>
                            <li className="menu-item "><NavLink to=""
                              title="Commercial Land">
                              Commercial Land</NavLink></li>
                            <li className="menu-item "><NavLink to=""
                              title="Industrial Land">
                              Industrial Land</NavLink></li>

                          </ul>
                        </li>
                        <li className="menu-item "><NavLink to=""
                          title="Buy / Sell Properties">
                          Buy / Sell Properties</NavLink></li>

                      </ul>



                    </li>
                    {/* <li className="menu-item">
                                            <NavLink className={({ isActive }) => (isActive ? "active" : '')} to="/services">Services</NavLink>
                                        </li> */}

                    <li className="menu-item">
                      <NavLink
                        className={({ isActive }) => (isActive ? "active" : "")}
                        to="/contact"
                      >
                        Contact Us
                      </NavLink>
                    </li>

                    <li className="menu-item">
                      <NavLink
                        className={({ isActive }) => (isActive ? "active" : "")}
                        to="/blog"
                      >
                        blog
                      </NavLink>
                    </li>


                    <li className="menu-item menu-item-has-children">
                      <NavLink
                        className={({ isActive }) => (isActive ? "" : "active")}
                        to=""
                        data-toggle="sub-menu"
                      >
                        My Account{" "}
                        <span className="plus">
                          <FiChevronDown />
                        </span>
                      </NavLink>
                      <ul className="sub-menu min-250">
                        {/* <li className="menu-item ">
                          <NavLink to="/my-orders" title="Investment">
                            My Orders
                          </NavLink>
                        </li> */}
                        <li className="menu-item ">
                          <NavLink to="/order-history" title="Buy / Sell Properties">
                            Order History
                          </NavLink>
                        </li>
                        <li className="menu-item ">
                          <NavLink to="/my-account" title="Buy / Sell Properties">
                            My Profile
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    {!loginData && (
                      <>
                        <li className="menu-item mb-view">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                            to="/login"
                          >
                            Login
                          </NavLink>
                        </li>
                        <li className="menu-item mb-view">
                          <NavLink
                            className={({ isActive }) =>
                              isActive ? "active sign-up-btn" : "sign-up-btn"
                            }
                            to="/signup"
                          >
                            signUp
                          </NavLink>
                        </li>
                      </>
                    )}
                  </ul>
                </div>

                <div>
                  <Link
                    className="close-nav-menu navbar-brand1"
                    onClick={toggleOpen}
                    to=""
                  >
                    <i className="fas fa-times"></i>
                  </Link>
                </div>
                {/* </div> */}
              </nav>

              {/* </div> */}
              {/* <div className="hed mart d-flex align-items-center">
                            <Link className="navbar-brand" to="/"><img className="show-1" src="assets/Images/logo-Final.png"
                                width="120px" alt="" /><img className="show-2" src="assets/Images/logo-light.png" width="120px"
                                    alt="" /></Link>

                        </div> */}
              <div>
                <button
                  className="navbar-toggler d-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNav"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <i className="fa-solid fa-bars-staggered"></i>
                </button>
              </div>

              {/* <div className="collapse navbar-collapse last-nav" id="navbarNav">
                            <ul className="navbar-nav last-nav">
                                <li className="nav-item">
                                    <NavLink  className={({isActive}) => (isActive ? "active nav-link" : 'nav-link')} aria-current="page" to="/saas-services">SAAS Services</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className={({isActive}) => (isActive ? "active nav-link" : 'nav-link')} to="/website-development">Website Development</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className={({isActive}) => (isActive ? "active nav-link" : 'nav-link')} to="/application-development">Mobile App Development</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink className={({isActive}) => (isActive ? "active nav-link" : 'nav-link')} to="/digital-marketing">Digital Marketing</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to="/contact" className={({isActive}) => (isActive ? "active nav-link" : 'nav-link')}>Contact Us</NavLink>
                                </li>
                            </ul>
                        </div> */}
              {/* <div className="dddhh"> </div> */}
              {/* <!-- </div> --> */}
              {/* </nav> */}
            </div>
            {!loginData && (
              <>
                <div className="mb-view-none d-lg-flex align-items-center">
                  <ul
                    className="menu  d-flex align-items-center"
                    style={{ marginBottom: "0px" }}
                  >
                    <li className="menu-item">
                      <NavLink
                        className={({ isActive }) => (isActive ? "active" : "")}
                        to="/login"
                      >
                        Login
                      </NavLink>
                    </li>
                    <li className="menu-item">
                      <NavLink
                        className={({ isActive }) =>
                          isActive ? "active sign-up-btn" : "sign-up-btn"
                        }
                        to="/signup"
                      >
                        signUp
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </>
            )}
            <div className="open-nav-menu d-flex align-items-center">
              <span className="d-inline-block mb-1" onClick={toggleOpen}>
                <FaBars />
              </span>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
